var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboarddark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6915 10.4344V4.89186C27.6915 3.17048 26.9101 2.47461 24.969 2.47461H20.0368C18.0957 2.47461 17.3144 3.17048 17.3144 4.89186V10.4222C17.3144 12.1558 18.0957 12.8395 20.0368 12.8395H24.969C26.9101 12.8517 27.6915 12.1558 27.6915 10.4344Z",
    fill: "#969696"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6915 24.1693V19.2371C27.6915 17.296 26.9101 16.5146 24.969 16.5146H20.0368C18.0957 16.5146 17.3144 17.296 17.3144 19.2371V24.1693C17.3144 26.1104 18.0957 26.8917 20.0368 26.8917H24.969C26.9101 26.8917 27.6915 26.1104 27.6915 24.1693Z",
    fill: "#969696"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6519 10.4344V4.89186C13.6519 3.17048 12.8706 2.47461 10.9295 2.47461H5.9973C4.05617 2.47461 3.27484 3.17048 3.27484 4.89186V10.4222C3.27484 12.1558 4.05617 12.8395 5.9973 12.8395H10.9295C12.8706 12.8517 13.6519 12.1558 13.6519 10.4344Z",
    fill: "#969696"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6519 24.1693V19.2371C13.6519 17.296 12.8706 16.5146 10.9295 16.5146H5.9973C4.05617 16.5146 3.27484 17.296 3.27484 19.2371V24.1693C3.27484 26.1104 4.05617 26.8917 5.9973 26.8917H10.9295C12.8706 26.8917 13.6519 26.1104 13.6519 24.1693Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboarddark);
export default __webpack_public_path__ + "static/media/dashboarddark.b62a6d62098c9b4344867f3026ea1280.svg";
export { ForwardRef as ReactComponent };